import cl from 'classnames';
import { noop } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

import { deviceBreakpoints } from '../../../../../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../../../../../colors-v2';
import { Typography } from '../../../../../DesignSystemV2/Typography';
import { ContentItemProps } from '../TableOfContentType';
import { onContentItemClick } from '../utils';

const Main = styled(Typography.Paragraph)`
  cursor: pointer;
  color: ${colorsV2.black70};
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
  overflow: hidden;

  @media not screen and ${deviceBreakpoints.fromDesktop} {
    white-space: pre-wrap;
    text-overflow: ellipsis;
  }
  &.active {
    color: ${colorsV2.primary100};
  }
  &.selected,
  &:hover {
    color: ${colorsV2.primary100};
  }
`;

export const ContentItem = (props: ContentItemProps): JSX.Element => {
  const {
    id,
    prefix,
    text,
    typographyVariant = 'medium/14',
    active,
    onClick = noop,
    scrollContainerElm,
  } = props;

  const tooltipTitle = prefix ? `${prefix} ${text}` : text;
  const title = prefix ? `${prefix} ${text}` : text;

  return (
    <Main
      aria-hidden="true"
      role="button"
      onClick={() => {
        onContentItemClick(id, scrollContainerElm);
        onClick?.();
      }}
      className={cl('content-item', { active })}
      ellipsis={{
        tooltip: tooltipTitle,
      }}
      variant={typographyVariant}
    >
      {title}
    </Main>
  );
};
